import { api } from "./api.js";
import { state } from "./state.js";

export const NAV_COLLAPSED_KEY = "fit1_mc_nav_collapsed";
export const NAV_SCHEMA_VERSION = "mcw-v40-fitting-records-v1";

export const FALLBACK_NAV = [
  { group: "超级管理员", items: [
    { href: "/static/platform-console.html#roles", title: "角色权限管理", perm: "mc:sys:rbac:manage", external: true },
    { href: "/static/rules-ruling.html?v=20261027-ruling-batch-detail", title: "业务裁决", perm: "mc:sys:rbac:manage", external: true },
    { href: "/static/drama-template-admin.html", title: "剧情模板", perm: "mc:sys:rbac:manage", external: true },
    { href: "/static/platform-virtual-actors.html?v=20261102-pa-v1", title: "虚拟主角管理", perm: "mc:sys:rbac:manage", external: true },
    { href: "/static/gb-pipeline-g1-g8-flow.html?v=20260926-gb-pub-ts", title: "G1–G8 总流程图", perm: "mc:sys:rbac:manage", external: true },
    { href: "/static/internal-kb-launcher.html?doc=i-readme&v=20261031-internal-kb2", title: "内部知识库", perm: "mc:sys:rbac:manage", external: true },
    { href: "/static/algo-test-archive.html?v=20260904-algo-v4", title: "算法测试", perm: "mc:sys:rbac:manage", external: true },
    { href: "/static/algo-pricing-admin.html", title: "算法成本单价表", perm: "mc:sys:rbac:manage", external: true },
    { href: "/static/ops-return-reasons.html", title: "退货原因字典", perm: "mc:sys:rbac:manage", external: true },
    // TRY-22：试穿价格表唯一改价口（平台专有）。与后端 NAV_ITEMS 同形。
    { href: "/static/ops-tryon-prices.html?v=20261101-tryon-price-v1", title: "试穿价格表", perm: "mc:sys:rbac:manage", external: true },
    { href: "/static/ops-tryon-report.html?v=20261101-tryon-report-v1", title: "试穿消耗对账", perm: "mc:sys:rbac:manage", external: true },
    { href: "/static/algo-call-admin.html", title: "算法调用查询", perm: "mc:sys:rbac:manage", external: true },
    { href: "/static/ops-fitting-records.html?v=20261024-fitting-v2", title: "量体记录", perm: "mc:sys:rbac:manage", external: true },
    { href: "/static/ops-brand.html", title: "品牌审核台", perm: "mc:sys:rbac:manage", external: true },
    { href: "/static/ops-persons.html", title: "系统用户", permAny: ["mc:sys:person:read", "mc:sys:rbac:manage"], external: true },
    { href: "/static/ops-audit.html?v=20261009-login-v2", title: "日志管理", perm: "mc:sys:rbac:manage", external: true },
    { href: "/static/ops-notices.html?v=20261027-notices-v1", title: "站内信", perm: "mc:sys:rbac:manage", external: true },
    { href: "/static/ops-system-status.html?v=20261002-sysstat-v1", title: "系统状态监控", perm: "mc:sys:rbac:manage", external: true },
    { href: "/static/platform-external-sales.html", title: "外部销售平台", perm: "mc:sys:rbac:manage", external: true },
  ] },
  { group: "运营", items: [
    { href: "/static/ops-onboarding.html", title: "入驻审核台", perm: "mc:sys:rbac:manage", external: true },
    { href: "/static/ops-audit.html?v=20261009-login-v2", title: "日志管理", perm: "mc:ops:merchant_roles:write", external: true },
    { href: "/static/ops-console.html", title: "商家管理", perm: "mc:ops:merchant_roles:write", external: true },
    { href: "/static/ops-b-miniapp.html", title: "B 端打包", permAny: ["ops:bminiapp:approve", "mc:ops:merchant_roles:write"], external: true },
    { href: "/static/ops-persons.html", title: "系统用户", perm: "mc:sys:person:read", external: true },
    { href: "/static/algo-call-admin.html", title: "算法调用查询", perm: "mc:ops:merchant_roles:write", external: true },
    { href: "/static/algo-test-archive.html?v=20260904-algo-v4", title: "算法测试", perm: "mc:ops:algo_test:read", external: true },
    { href: "/demo-size-templates", title: "尺码模板", perm: "mc:ops:templates:read", external: true },
    { href: "/static/ops-shop-bind.html", title: "店铺绑定审批", perm: "mc:ops:shop_bind:read", external: true },
    { href: "/static/ops-creator-episodes.html", title: "短剧作品审核", perm: "mc:ops:merchant_roles:write", external: true },
    { href: "/static/ops-creator-recharge.html?v=20261026-recharge-v2", title: "充值对账", perm: "mc:ops:recharge:read", external: true },
    { href: "/static/ops-creators.html?v=20261102-creator-tier", title: "创作者账户", perm: "mc:ops:creator:read", external: true },
  ] },
  { group: "短剧创作", items: [
    { route: "drama", title: "我的作品", perm: "mc:drama:read" },
    { route: "drama-monitor", title: "生成监控", perm: "mc:drama:read" },
    { route: "actors", title: "主角", perm: "mc:drama:read" },
    { href: "/static/drama-scenes.html?v=20260828-back-topright", title: "场景", perm: "mc:drama:read", external: true },
    { href: "/static/drama-commerce.html?v=20260829-commerce-v1", title: "开放带货", perm: "mc:drama:read", external: true },
    { href: "/static/drama-funnel.html", title: "带货分析", perm: "mc:drama:read", external: true },
  ] },
  { group: "经营", items: [
    { route: "categories", title: "产品类别" },
    { route: "stores", title: "自有门店", perm: "mc:retail:store:read" },
    { route: "mall-orders", title: "商城订单", perm: "mc:mall:order:read" },
    { route: "mall-reconcile", title: "支付对账", perm: "mc:mall:order:read" },
    { href: "/static/merchant-tryon-policy.html?v=20261101-tryon-policy-v1", title: "试穿代付", perm: "mc:mall:tryon:read", external: true },
  ] },
  { group: "品牌", items: [
    { route: "brand", title: "品牌管理", perm: "mc:brand:read" },
    { route: "channel-reviews", title: "经销审核", perm: "mc:brand:write" },
    {
      // 版本号跟着 drama-garments.html 自己的资源指纹走；2026-10-22 起是 pager。
      // （那次只改了构建产物没改这里，重构建会把链接打回旧串、命中浏览器旧缓存。）
      href: "/static/drama-garments.html?v=20261022-pager&entry=list",
      title: "服装",
      perm: "mc:brand:catalog:read",
      external: true,
      hideWhenMerchantHasDist: true,
    },
    {
      href: "/static/garment-downstream.html?v=20261028-grant-revoke",
      title: "下游上货",
      perm: "mc:brand:downstream:read",
      external: true,
      hideWhenMerchantHasDist: true,
    },
    // 尺码组（P5.5-5）· 与后端 NAV_ITEMS 同源同形。`embedPanel` 不是 `external`：
    // 前者跨域（先向平台要绝对地址），后者同源 iframe —— 见 router.js 的 EMBED_PANELS。
    {
      route: "md-sizegroups",
      title: "尺码组",
      perm: "mc:brand:sizegroup:read",
      embedPanel: "dist-md",
      hideWhenMerchantHasDist: true,
    },
    {
      href: "/pb/pattern-catalog.html?v=20261004-pb",
      title: "版型资料",
      perm: "mc:brand:catalog:read",
      external: true,
    },
  ] },
  { group: "使用指南", items: [
    { href: "/static/guide/start.html?v=20260918-guide-v1", title: "开始使用", perm: "mc:docs:read", external: true },
    { href: "/static/guide/fit.html?v=20260918-guide-v1", title: "合身与量体", perm: "mc:docs:read", external: true },
    { href: "/static/guide/brand.html?v=20260918-guide-v1", title: "品牌与货盘", perm: "mc:docs:read", external: true },
    { href: "/static/guide/drama.html?v=20260918-guide-v1", title: "短剧与结算", perm: "mc:docs:read", external: true },
    { href: "/static/guide/federation.html?v=20260918-guide-v1", title: "分销与生产", perm: "mc:docs:read", external: true },
    { href: "/static/guide/devtools.html?v=20260918-guide-v1", title: "开发者接入", perm: "mc:docs:read", external: true },
    { href: "/static/guide/glossary.html?v=20260918-guide-v1", title: "术语与规范", perm: "mc:docs:read", external: true },
    { href: "/static/rules-launcher.html?v=20261007-rules-v1", title: "业务规则总账", perm: "mc:docs:read", external: true },
  ] },
  { group: "开发（接口开发）", platformSuperAdminOnly: true, items: [
    { route: "onboarding", title: "入驻与审核", perm: "mc:onboarding:read" },
    { route: "credentials", title: "凭证与安全", perm: "mc:credentials:read" },
    { route: "capabilities", title: "能力配置", perm: "mc:capabilities:read" },
    { route: "sync", title: "同步与日志", perm: "mc:sync:read" },
    { route: "usage", title: "用量与配额", perm: "mc:usage:read" },
    { href: "/demo-merchant", title: "API 测试台", perm: "mc:devtools:read", external: true },
  ] },
  { group: "账户", items: [
    { route: "overview", title: "概览", perm: "mc:overview:read" },
    { route: "team", title: "团队", perm: "mc:team:read" },
    // `staffVisible`：**在册员工恒可见**（2026-10-14 主人裁 B）。零角色员工也要能进
    // 个人中心看清「我是谁、被哪家店收了、当前没有角色」——见下方 `canSee`。
    { route: "account", title: "个人中心", perm: "mc:overview:read", staffVisible: true },
    { route: "cap-open", title: "能力开通", perm: "mc:overview:read" },
    { route: "bminiapp", title: "我的小程序", perm: "mc:bminiapp:read" },
    {
      href: "/static/merchant-shop-bind.html",
      title: "店铺与采集",
      perm: "mc:merchant:shop_bind:read",
      external: true,
    },
    { folder: true, title: "结算", children: [
      { href: "/static/drama-settlement.html?v=20261102-settle-jimeng-asset&tab=members", title: "成员绑定", perm: "mc:drama:read", external: true },
      { href: "/static/drama-settlement.html?v=20261102-settle-jimeng-asset&tab=spend", title: "团队花费报表", perm: "mc:drama:read", external: true },
      { href: "/static/drama-settlement.html?v=20261102-settle-jimeng-asset&tab=statements", title: "月结账单", perm: "mc:drama:read", external: true },
      { href: "/static/drama-settlement.html?v=20261102-settle-jimeng-asset&tab=commission", title: "款级佣金", perm: "mc:brand:commission:read", external: true },
    ] },
  ] },
];

export function defaultConsoleRoute() {
  // 零角色员工：菜单里**只剩**「个人中心」，落到 `overview` 只会被 router 再改一次路由
  // （`#overview` 没有对应链接 ⇒ 跳第一项），直接给 `account` 更干净，也不会闪。
  if (isConsoleStaff() && !(window.McAuth && window.McAuth.hasPerm && window.McAuth.hasPerm("mc:overview:read"))) {
    return "account";
  }
  if (window.McAuth && window.McAuth.hasPerm && !window.McAuth.hasPerm("mc:drama:read")) {
    return "overview";
  }
  return "drama";
}

function normalizeNavGroups(groups) {
  return Array.isArray(groups) && groups.length ? groups : FALLBACK_NAV;
}

/** 按 `route` 回查 NAV 定义。
 *
 * 路由要认的是**承载标记**（如 `embedPanel`）这类信息，而 `a[data-route]` 上只有
 * route —— 只能回查这份数据。判据必须是「当前真正在用的那份」（`state.nav`，
 * 后端下发的）而不是 FALLBACK_NAV，否则后端新加的项在路由里认不出来。
 */
export function navItemByRoute(route) {
  const groups = normalizeNavGroups(state.nav || FALLBACK_NAV);
  for (const g of groups) {
    for (const it of g.items || []) {
      if (it && it.route === route) return it;
    }
  }
  return null;
}

function isPlatformSuperAdminClient() {
  return !!(window.McAuth && window.McAuth.isPlatformSuperAdmin && window.McAuth.isPlatformSuperAdmin());
}

/** 本会话是否「本店已接分销 dist ⇒ 平台侧同能力入口让位」。
 *
 * 判据单一来源：NAV 的 `hideWhenMerchantHasDist` 与能力面板的「货架登记」块
 * （`panels/index.js renderCapabilitiesPanel`）共用本函数，避免两处判据漂移。
 * 平台超管保留可见（排查用）。 */
export function merchantHasDistGated() {
  return !!(state.merchantHasDist && !isPlatformSuperAdminClient());
}

/** 本会话是不是「本店在册员工」。
 *
 * 判据是 `/merchant/me` 的 `console_staff` —— 后端 `attach_console_rbac` **只在人级分支**
 * 写这个字段（本店名册 `active` 的 person）。店主 / 老登录者 / Api-Key 会话都没有它。 */
function isConsoleStaff() {
  return !!(state.me && state.me.console_staff);
}

export function canSee(item) {
  if (!item) return true;
  // `staffVisible`（2026-10-14 主人裁 B）：在册员工恒可见，**不看权限码** —— 零角色员工
  // 也要能进「个人中心」。与 `platformSuperAdminOnly` / `hideWhenMerchantHasDist` 同类，
  // 是 NAV 数据上的标记，先于 per-item perm 生效。对店主/非员工不生效（他们没 `console_staff`）。
  if (item.staffVisible && isConsoleStaff()) return true;
  if (item.permAny && Array.isArray(item.permAny)) {
    return window.McAuth && window.McAuth.hasAny
      ? window.McAuth.hasAny(item.permAny)
      : item.permAny.some((p) => canSee({ perm: p }));
  }
  if (!item.perm) return true;
  return window.McAuth ? window.McAuth.hasPerm(item.perm) : true;
}

function canSeeGroup(g) {
  if (g && g.platformSuperAdminOnly) return isPlatformSuperAdminClient();
  return true;
}

function navItemVisible(it) {
  if (it && it.hideWhenMerchantHasDist && merchantHasDistGated()) {
    return false;
  }
  if (it && it.folder && it.children) {
    return (it.children || []).some(canSee);
  }
  return canSee(it);
}

function appendNavLink(body, it) {
  const a = document.createElement("a");
  if (it.external) {
    a.href = "#ext=" + encodeURIComponent(it.href || "");
    a.dataset.extHref = it.href || "";
    a.classList.add("mcp-nav-external");
  } else {
    a.href = "#" + it.route;
    a.dataset.route = it.route;
  }
  a.textContent = it.title;
  body.appendChild(a);
}

function appendNavItems(body, items, groupName) {
  (items || []).forEach((it) => {
    if (!navItemVisible(it)) return;
    if (it.folder && it.children) {
      const sub = document.createElement("div");
      sub.className = "mcp-tree-subgroup";
      const subKey = `${groupName || ""}::${it.title || ""}`;
      sub.dataset.sub = subKey;
      const subHead = document.createElement("button");
      subHead.type = "button";
      subHead.className = "mcp-tree-subhead";
      subHead.appendChild(document.createTextNode(it.title || "分组"));
      const chev = document.createElement("span");
      chev.className = "chev";
      chev.textContent = "▾";
      subHead.appendChild(chev);
      const subBody = document.createElement("div");
      subBody.className = "mcp-tree-subbody";
      (it.children || []).filter(canSee).forEach((child) => appendNavLink(subBody, child));
      subHead.addEventListener("click", () => {
        sub.classList.toggle("open");
        persistCollapsedGroups();
      });
      sub.appendChild(subHead);
      sub.appendChild(subBody);
      sub.classList.toggle("open", !readCollapsedGroups().includes(subKey));
      body.appendChild(sub);
      return;
    }
    appendNavLink(body, it);
  });
}

/** 一级菜单互斥：展开其中一个时收起其余一级 */
export function setExclusiveGroupOpen(openGroup) {
  document.querySelectorAll("#side-nav .mcp-tree-group").forEach((g) => {
    g.classList.toggle("open", !!openGroup && g === openGroup);
  });
  persistCollapsedGroups();
}

function readCollapsedGroups() {
  try {
    return JSON.parse(localStorage.getItem(NAV_COLLAPSED_KEY) || "[]");
  } catch {
    return [];
  }
}

function persistCollapsedGroups() {
  const closed = [];
  document.querySelectorAll("#side-nav .mcp-tree-group").forEach((g) => {
    if (!g.classList.contains("open") && g.dataset.group) closed.push(g.dataset.group);
  });
  document.querySelectorAll("#side-nav .mcp-tree-subgroup").forEach((s) => {
    if (!s.classList.contains("open") && s.dataset.sub) closed.push(s.dataset.sub);
  });
  localStorage.setItem(NAV_COLLAPSED_KEY, JSON.stringify(closed));
}

export function buildNav() {
  const nav = document.getElementById("side-nav");
  if (!nav) return;
  nav.innerHTML = "";
  const groups = normalizeNavGroups(state.nav || FALLBACK_NAV);
  const closed = readCollapsedGroups();
  let anyVisible = false;
  const built = [];
  groups.forEach((g) => {
    if (!canSeeGroup(g)) return;
    const items = (g.items || []).filter(navItemVisible);
    if (!items.length) return;
    anyVisible = true;
    const grp = document.createElement("div");
    grp.className = "mcp-tree-group";
    if (g.group) grp.dataset.group = g.group;
    const head = document.createElement("button");
    head.type = "button";
    head.className = "mcp-tree-head";
    head.appendChild(document.createTextNode(g.group || "菜单"));
    const chev = document.createElement("span");
    chev.className = "chev";
    chev.textContent = "▾";
    head.appendChild(chev);
    head.addEventListener("click", () => {
      const willOpen = !grp.classList.contains("open");
      setExclusiveGroupOpen(willOpen ? grp : null);
    });
    const body = document.createElement("div");
    body.className = "mcp-tree-body";
    appendNavItems(body, items, g.group);
    grp.appendChild(head);
    grp.appendChild(body);
    nav.appendChild(grp);
    built.push({ grp, group: g.group, wasOpen: !(g.group && closed.includes(g.group)) });
  });
  // 互斥初始化：优先当前激活链所在一级；否则取曾展开的第一项；再否则第一组
  const hash = String(location.hash || "").replace(/^#/, "");
  let prefer = null;
  if (hash.indexOf("ext=") === 0) {
    try {
      const target = decodeURIComponent(hash.slice(4));
      const hit = Array.from(nav.querySelectorAll("a[data-ext-href]")).find(
        (a) => (a.dataset.extHref || "") === target
      );
      if (hit) prefer = hit.closest(".mcp-tree-group");
    } catch (_) {
      /* ignore */
    }
  } else if (hash) {
    const activeLink = nav.querySelector(`a[data-route="${CSS.escape(hash)}"]`);
    if (activeLink) prefer = activeLink.closest(".mcp-tree-group");
  }
  if (!prefer) {
    const remembered = built.find((b) => b.wasOpen);
    prefer = remembered ? remembered.grp : built[0] && built[0].grp;
  }
  setExclusiveGroupOpen(prefer || null);
  const empty = document.getElementById("nav-empty");
  if (empty) {
    // 空态文案分两种：**已入店但零角色**的员工（BS-05）要说清「加入成功、等分配」，
    // 否则会被读成「系统坏了 / 我没进去」。其余（如平台超管的小店、误配）保持旧文案。
    const me = state.me || {};
    const staff = me.console_staff || null;
    const hasPerm = Array.isArray(me.permissions) && me.permissions.length > 0;
    // 名册行被停用（`console_access_state=suspended`）：后端 `attach_console_rbac` 同样给
    // 空角色空权限，但原因**不是**「还没分配」，文案必须分开，否则用户以为等分配就好。
    const suspendedStaff = !!staff && String(staff.status || "active") === "suspended";
    const zeroRoleStaff = !!staff && !suspendedStaff && !hasPerm;
    const staffBlocked = suspendedStaff || zeroRoleStaff;
    empty.textContent = suspendedStaff
      ? "你在本店的权限已被停用 —— 如需恢复，请联系本店管理员。"
      : zeroRoleStaff
        ? "你已加入本店，管理员还没有为你分配权限 —— 暂时只有「个人中心」可用。请联系本店管理员。"
        : "当前角色无可见菜单";
    // 零角色 / 已停用员工：**即使「个人中心」让侧栏有了一行**，这句说明也要留着 ——
    // 侧栏只剩一个孤零零的入口，不说清反而更像「系统坏了」（契约 §0-115）。
    empty.classList.toggle("hidden", !staffBlocked && anyVisible);
  }
  const quick = document.getElementById("overview-drama-links");
  const dramaVisible = canSee({ perm: "mc:drama:read" });
  if (quick) quick.classList.toggle("hidden", !dramaVisible);
  const quickSection = quick && quick.closest(".mc-overview-section");
  if (quickSection) quickSection.classList.toggle("hidden", !dramaVisible);
}


export async function loadRbacMatrix() {
  const ver = localStorage.getItem("fit1_mc_nav_schema");
  const { ok, data } = await api("GET", "/api/v1/merchant/console/rbac-matrix", { merchant: true });
  if (ok && data) {
    state.merchantHasDist = !!data.merchant_has_dist;
  }
  if (ok && data && Array.isArray(data.nav) && data.nav.length) {
    state.nav = normalizeNavGroups(data.nav);
    localStorage.setItem("fit1_mc_nav_schema", NAV_SCHEMA_VERSION);
  } else if (ver !== NAV_SCHEMA_VERSION) {
    state.nav = null;
  }
}
